import { AbstractControl, ValidationErrors } from '@angular/forms';

export const minDate = new Date(1901, 0, 1, 2, 0);

export function minDateValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;
  const birthDate = new Date(control.value);
  return birthDate > minDate ? null : { minDate: true };
}
